import React, { Fragment, useState } from "react";
import useColour from "../../../services/settings/useColour";
import FlightRampStatus from "../../../modules/RampActions/components/FlightRampStatus";
import { Dvr } from "@material-ui/icons";
import ChromeTabs from "../../ChromeTabs";

const MonitorScreen = (props) => {
  const {tripData} = props; 

  const {aircraftReg, originAirportCode, destinationAirportCode, airlineCode, flightNo, std, sta} = tripData;

  const directionTabs =
  [
    {label: "Out", value: "OUTBOUND"},
    {label: "In", value: "INBOUND"},
  ];

  const [direction, setDirection] = useState("OUTBOUND");

  const handleTabChange = (e, i) => {
    setDirection(i);
  }

  return (<Fragment>
    <div style={{width: "100%", paddingBottom: 5}}>
      <div style={{display: "inline-block"}}><Dvr style={{position: "relative", top: 2}}/></div>
      <div style={{display: "inline-block", textAlign: "left", fontSize: 20, fontWeight: "bold", marginLeft: 3}}>Monitor</div>
      <div style={{display: "inline-block", float:"right", textAlign: "right"}}>
        <ChromeTabs
          id={"direction"}
          //style={{ alignSelf: "flex-end", display: "inline-block", align: "left" }}
          style={{ marginTop: 3, marginRight: 5, padding: 0 }}
          tabs={directionTabs}
          tabStyle={{
            bgColor: "#E6E8EB",
            selectedBgColor: "#ffffff",
            color: "rgba(0,0,0,0.87)",
            padding: 0,
            // minWidth: "sd",
            // width: 10
          }}
          tabProps={{
            disableRipple: false,
            style:{
              padding: 0, 
              maxHeight: 10,
              minWidth: 50,
              minHeight: 30 
            }
            // minWidth: 20,
            // width: 10,
          }}
          value={direction}
          onChange={handleTabChange}
        />

        {/* <ActionButton 
          variant="outlined" 
          startIcon={<Icon>add</Icon>}
          onClick={()=>{
            eventBus.trigger("RouteView.TimeWindow.TripAction.addNote",{tripLegUuid: tripData.uuid, noteType, title: `Flight Note for  ${tripData.airlineCode}${tripData.flightNo} ${moment.utc(tripData.scheduledDepartureTimeUTC).format("D MMM")}`});
          }}
        >
          Add
        </ActionButton> */}
      </div>
      <FlightRampStatus 
        airportCode={direction==='INBOUND'?destinationAirportCode:originAirportCode}
        direction={direction || 'OUTBOUND'} 
        flightNumber={`${airlineCode}${flightNo}`} 
        aircraft={aircraftReg} 
        scheduledTime={direction==='INBOUND'?sta:std}
      />
    </div>

  </Fragment>); 
}

export default MonitorScreen;